import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <div className="h-1 w-full bg-primary-500" />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-20">
        <span className="font-heading text-6xl md:text-8xl font-extrabold text-primary-500">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已下线、链接有误，或内容暂时不可用。可以返回首页，或前往电影分类继续浏览韩国剧情与理论电影。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 font-label text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-300 bg-background-50 font-label text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-film-line" aria-hidden="true" />
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}